module.exports = __webpack_public_path__ + "img/TRAINING_OUT.6373f737.svg";